var _rect, _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDrapeauTunisie(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 17,
    viewBox: "0 0 24 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 23,
    height: 16,
    stroke: "#5754E5",
    strokeOpacity: 0.15
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23 1H1V16H23V1Z",
    fill: "url(#paint0_linear_10403_49066)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0013 12.8998C14.3775 12.8998 16.3034 10.9297 16.3034 8.49997C16.3034 6.07022 14.3771 4.1001 12.0013 4.1001C9.62509 4.1001 7.69922 6.07022 7.69922 8.49997C7.69922 10.9297 9.62509 12.8998 12.0013 12.8998ZM13.1542 9.26857L12.3319 10.4391L12.3244 8.99775L10.9817 8.55957L12.3197 8.10709L12.3123 6.66574L13.1468 7.82721L14.4848 7.37473L13.6624 8.54527L14.4969 9.70722L13.1542 9.26857ZM12.0353 5.21342C12.9715 5.21342 13.8144 5.61679 14.4097 6.26237C13.9985 5.99441 13.5109 5.83897 12.9873 5.83897C11.5221 5.83897 10.3342 7.05385 10.3342 8.55242C10.3342 10.051 11.5221 11.2659 12.9873 11.2659C13.5109 11.2659 13.9985 11.11 14.4097 10.8425C13.8144 11.4876 12.971 11.8914 12.0353 11.8914C10.2326 11.8914 8.77055 10.3967 8.77055 8.55242C8.77055 6.70817 10.2321 5.21342 12.0353 5.21342Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_10403_49066",
    x1: 1,
    y1: 8.49993,
    x2: 22.9998,
    y2: 8.49993,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CF1400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF1400"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrapeauTunisie);
export default __webpack_public_path__ + "static/media/drapeauTunisie.ac7e3ac4c78be974cd13870279327175.svg";
export { ForwardRef as ReactComponent };